// User action types
export const SET_USER = 'SET_USER';
export const CLEAR_USER = 'CLEAR_USER';
